import React, { Component } from 'react'
import $ from 'jquery'
import swal from 'sweetalert2'
import { FormattedMessage } from 'react-intl'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import * as Constants from '../atributoDinamico/constants.js'

// VEC-3476: modal dedicado a resolver los ítems de "Mínimo Vital" pendientes de
// un checklist puntual. A diferencia de ValidacionGranularModal (que muestra
// TODOS los ítems y permite validar/rechazar/deshacer), este modal:
// - solo lista lo que todavía está pendiente (GET /formulario/{id}/minimo-vital),
// - solo permite "resolver" (decision=VALIDO), sin deshacer,
// - al concluir, reusa POST /formulario/{id}/validar-items (mismo endpoint que
//   ValidacionGranularModal) y reacciona a `requiere_seleccion_estado_movil` en
//   la respuesta para avisarle al padre si corresponde ofrecer el cambio de estado.
class MinimoVitalModal extends Component {
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();
		this.concluido = false;
		this.requiereSeleccionEstadoMovil = false;

		this.state = {
			modalId: 'modal_minimo_vital_' + props.formularioId,
			loading: true,
			submitting: false,
			pendientes: [],
			resueltosBorrador: {},
		};

		this.handleCerrar = this.handleCerrar.bind(this);
		this.handleConcluir = this.handleConcluir.bind(this);
	}

	componentDidMount() {
		this.ajaxHandler.subscribe(this);
		let component = this;
		$('#' + this.state.modalId).modal({ backdrop: 'static' });
		$('#' + this.state.modalId).on('hidden.bs.modal', function () {
			if (component.concluido) {
				component.props.onConcluido(component.requiereSeleccionEstadoMovil);
			} else {
				component.props.onClose();
			}
		});
		this.cargarPendientes();
	}

	componentWillUnmount() {
		$('#' + this.state.modalId).off('hidden.bs.modal');
		this.ajaxHandler.unsubscribe();
	}

	cargarPendientes() {
		this.setState({ loading: true });
		let component = this;
		this.ajaxHandler.getJson('/formulario/' + this.props.formularioId + '/minimo-vital').then(function (pendientes) {
			component.setState({ pendientes: pendientes || [], loading: false });
		}).catch(function (error) {
			console.log(error);
			component.setState({ loading: false });
		});
	}

	handleCerrar() {
		$('#' + this.state.modalId).modal('hide');
	}

	marcarResuelto(valorDinamico) {
		let intl = this.props.intl;
		let component = this;
		// Mismo fix de foco que ValidacionGranularModal: el swal se monta fuera del modal Bootstrap.
		$(document).off('focusin.modal');
		swal({
			title: intl.formatMessage({ id: 'formularios.minimoVital.resolver_titulo', defaultMessage: 'Resolver falla de Mínimo Vital' }),
			text: intl.formatMessage({ id: 'formularios.minimoVital.resolver_texto', defaultMessage: 'Ingresá un comentario (obligatorio, máx. 240 caracteres).' }),
			icon: 'question',
			input: 'textarea',
			inputPlaceholder: intl.formatMessage({ id: 'formularios.minimoVital.comentario_placeholder', defaultMessage: 'Comentario...' }),
			inputAttributes: { maxlength: 240 },
			showCancelButton: true,
			confirmButtonText: intl.formatMessage({ id: 'formularios.minimoVital.boton_resolver', defaultMessage: 'Resolver' }),
			cancelButtonText: intl.formatMessage({ id: 'formularios.minimoVital.boton_cancelar_swal', defaultMessage: 'Cancelar' }),
			inputValidator: (value) => {
				if (!value || !value.trim()) {
					return intl.formatMessage({ id: 'formularios.minimoVital.comentario_obligatorio_swal', defaultMessage: 'El comentario es obligatorio.' });
				}
				if (value.trim().length > 240) {
					return intl.formatMessage({ id: 'formularios.minimoVital.comentario_muy_largo_swal', defaultMessage: 'El comentario no puede superar los 240 caracteres.' });
				}
				return null;
			},
		}).then((result) => {
			if (result.value !== undefined && result.value !== false) {
				let motivo = result.value.trim();
				component.setState(function (prevState) {
					let resueltosBorrador = Object.assign({}, prevState.resueltosBorrador);
					resueltosBorrador[valorDinamico.id] = {
						motivo: motivo,
						ultima_validacion_id: valorDinamico.ultima_validacion ? valorDinamico.ultima_validacion.id : null,
					};
					return { resueltosBorrador: resueltosBorrador };
				});
			}
		});
	}

	quitarMarca(valorDinamicoId) {
		this.setState(function (prevState) {
			let resueltosBorrador = Object.assign({}, prevState.resueltosBorrador);
			delete resueltosBorrador[valorDinamicoId];
			return { resueltosBorrador: resueltosBorrador };
		});
	}

	handleConcluir() {
		let component = this;
		let intl = this.props.intl;
		let resueltosBorrador = this.state.resueltosBorrador;
		let ids = Object.keys(resueltosBorrador);
		if (ids.length === 0) return;

		let payload = ids.map(function (id) {
			let item = resueltosBorrador[id];
			return {
				valor_dinamico_id: parseInt(id, 10),
				decision: Constants.ID_DECISION_VALIDO,
				motivo: item.motivo,
				ultima_validacion_id: item.ultima_validacion_id,
			};
		});

		this.setState({ submitting: true });

		this.ajaxHandler.fetch('/formulario/' + this.props.formularioId + '/validar-items', {
			method: 'POST',
			silent: true,
			body: JSON.stringify(payload),
		}).then(function (response) {
			if (response.status === 200) {
				component.concluido = true;
				response.json().then(function (data) {
					component.requiereSeleccionEstadoMovil = !!(data && data.requiere_seleccion_estado_movil);
					swal({
						title: intl.formatMessage({ id: 'formularios.minimoVital.exito_titulo', defaultMessage: 'Mínimo Vital actualizado' }),
						icon: 'success',
					}).then(function () {
						$('#' + component.state.modalId).modal('hide');
					});
				});
			} else if (response.status === 409) {
				component.setState({ submitting: false });
				swal({
					title: intl.formatMessage({ id: 'formularios.minimoVital.conflicto_titulo', defaultMessage: 'Alguien más ya actualizó este ítem' }),
					text: intl.formatMessage({ id: 'formularios.minimoVital.conflicto_texto', defaultMessage: 'Cerrá y volvé a abrir para ver los datos actualizados.' }),
					icon: 'warning',
				});
			} else {
				component.setState({ submitting: false });
				response.json().then(function (data) {
					swal({
						title: intl.formatMessage({ id: 'formularios.minimoVital.error_titulo', defaultMessage: 'No se pudo guardar' }),
						text: (data && data.error) ? data.error : '',
						icon: 'error',
					});
				}).catch(function () {
					swal({ title: intl.formatMessage({ id: 'formularios.minimoVital.error_titulo', defaultMessage: 'No se pudo guardar' }), icon: 'error' });
				});
			}
		}).catch(function (error) {
			component.setState({ submitting: false });
			component.ajaxHandler.handleError(error);
		});
	}

	renderItem(valorDinamico) {
		let borrador = this.state.resueltosBorrador[valorDinamico.id];
		let nombre = valorDinamico.atributo_dinamico ? valorDinamico.atributo_dinamico.nombre : '';

		return (
			<div className="row align-items-start border-bottom py-2 mx-0" key={valorDinamico.id}>
				<div className="col-7 text-truncate" title={nombre}>
					{nombre}
				</div>
				<div className="col-5">
					{borrador ? (
						<div className="text-truncate">
							<small className="success">
								<strong><FormattedMessage id="formularios.minimoVital.pendiente_de_guardar" defaultMessage="Pendiente:" /></strong>
								{' '}
								<FormattedMessage id="formularios.minimoVital.decision_resolver_accion" defaultMessage="Resolver" />
								{borrador.motivo ? (' (' + borrador.motivo + ')') : ''}
							</small>
							<button type="button" className="btn btn-sm btn-link p-0 ml-1" onClick={() => this.quitarMarca(valorDinamico.id)}>
								<FormattedMessage id="formularios.minimoVital.quitar_marca" defaultMessage="Deshacer" />
							</button>
						</div>
					) : (
						<button
							className="btn btn-sm btn-icon btn-dt-grid text-success"
							title={this.props.intl.formatMessage({ id: 'formularios.minimoVital.boton_resolver', defaultMessage: 'Resolver' })}
							onClick={() => this.marcarResuelto(valorDinamico)}
						>
							<i className="fa fa-check"></i>{' '}
							<FormattedMessage id="formularios.minimoVital.boton_resolver" defaultMessage="Resolver" />
						</button>
					)}
				</div>
			</div>
		);
	}

	render() {
		let cantidadPorResolver = Object.keys(this.state.resueltosBorrador).length;

		return (
			<div className="modal fade" tabIndex="-1" id={this.state.modalId} role="dialog" aria-labelledby={this.state.modalId + '_label'}>
				<div className="modal-dialog modal-lg" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white" id={this.state.modalId + '_label'}>
								<i className="ft-alert-triangle align-middle icon-modal-title"></i>
								<FormattedMessage id="formularios.minimoVital.titulo_modal" defaultMessage="Fallas de Mínimo Vital" />
							</h4>
						</div>
						<div className="modal-body modal-grey modal-mh" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
							{this.state.loading ? (
								<div className="text-center py-4">
									<i className="fa fa-spinner fa-spin fa-2x"></i>
								</div>
							) : this.state.pendientes.length === 0 ? (
								<div className="text-center py-4 text-muted">
									<FormattedMessage id="formularios.minimoVital.sin_pendientes" defaultMessage="No hay fallas de Mínimo Vital pendientes en este checklist." />
								</div>
							) : (
								<React.Fragment>
									<div className="row font-weight-bold border-bottom pb-1 mx-0">
										<div className="col-7"><FormattedMessage id="formularios.minimoVital.col_item" defaultMessage="Ítem" /></div>
										<div className="col-5"><FormattedMessage id="formularios.minimoVital.col_accion" defaultMessage="Acción" /></div>
									</div>
									{this.state.pendientes.map((valorDinamico) => this.renderItem(valorDinamico))}
								</React.Fragment>
							)}
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" onClick={this.handleCerrar} disabled={this.state.submitting}>
								<FormattedMessage id="formularios.minimoVital.boton_cerrar" defaultMessage="Cerrar" />
							</button>
							<button
								type="button"
								className="btn btn-primary"
								onClick={this.handleConcluir}
								disabled={cantidadPorResolver === 0 || this.state.submitting}
							>
								{this.state.submitting && <i className="fa fa-spinner fa-spin mr-1"></i>}
								<FormattedMessage id="formularios.minimoVital.boton_concluir" defaultMessage="Guardar" />
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default MinimoVitalModal
